import React, { useState, useEffect, useRef } from "react";
import InputDatoProdotto from "../../../modificaProdotti/elementiPagina/InputDatoProdotto";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
/* import { useState } from "react";
import apiUrl from "../../../Apiurl"; */
import ImgArt from "./ImgArt";
import { BlockSkeleton } from "../../../interfaccia/loading";
import axios from "axios";
import apiUrl from "../../../Apiurl";
import { useAuth0 } from "@auth0/auth0-react";
import "./articolo.css";

const SNAPSHOT_MAGAZZINI_DEFAULT = [
  { sigla: "VM", label: "Villanova Mondovì" },
  { sigla: "PN", label: "Prato Nevoso" },
  { sigla: "JS", label: "Jolly Sport" },
  { sigla: "CH", label: "Cherasco" },
  { sigla: "RV", label: "Royal Park Roveri" },
  { sigla: "VE", label: "Vernante" },
  { sigla: "L4", label: "Limone 1400" },
  { sigla: "CU", label: "Borgo San Dalmazzo" },
  { sigla: "LM", label: "Limone" },
  { sigla: "MG", label: "Marro" },
];

const SIGLE_SNAPSHOT_SUPPORTATE = new Set([
  "VM",
  "PN",
  "JS",
  "CH",
  "RV",
  "MA",
  "VE",
  "L4",
  "CU",
  "LM",
  "MG",
]);

function Articolo({
  utente,
  articolo,
  handleChange,
  className,
  i,
  handleChangeImportoArticolo,
  onRimborsaArticolo,
  rimborsoPresente,
  permessi,
  idOrdinePS,
  idOrdineDatabase,
  fonteOrdine,
  rimuoviDaArr,
  onArticoloSpostato,
  onCreaSplit,
  splitInCorso,
  modificheNonSalvate,
  magazziniAttivi,
}) {
  /* const [immagine, setImmagine] = useState(false) */

  const [mostraModaInfo, setMostraModaInfo] = useState(false);
  const [modaInfo, setModaInfo] = useState(null);
  const [loadingModa, setLoadingModa] = useState(false);
  const [erroreModa, setErroreModa] = useState("");
  const [copiedModaValue, setCopiedModaValue] = useState("");
  const [showSnapshot, setShowSnapshot] = useState(false);
  const [showSpostamentoModa, setShowSpostamentoModa] = useState(false);
  const [showSpostamentoManuale, setShowSpostamentoManuale] = useState(false);
  const [opzioniSpostamentoModa, setOpzioniSpostamentoModa] = useState(null);
  const [loadingSpostamentoModa, setLoadingSpostamentoModa] = useState(false);
  const [erroreSpostamentoModa, setErroreSpostamentoModa] = useState("");
  const richiestaOpzioniRef = useRef(null);

  const [alertSalvataggio, setAlertSalvataggio] = useState(false);
  const [conferma, setConferma] = useState(false);
  const [rimborsoParziale, setRimborsoParziale] = useState(false);
  const [quantitaRimborsata, setQuantitaRimborsata] = useState("1");
  const [eliminazioneInCorso, setEliminazioneInCorso] = useState(false);
  const { getAccessTokenSilently, user } = useAuth0();
  const [token, setToken] = useState("");
  // Congelati solo gli import con tripletta Moda (28/10/2026): gli import senza
  // tripletta sono fuori circuito, come i custom. Senza fuori_circuito
  // dall'API resta la regola precedente.
  const identitaCongelata = articolo?.magazzino?.provenienza === "IMPORT_SITO"
    && !articolo.magazzino.fuori_circuito;
  const canUpdateLogistica = Boolean(utente?.permessiAPI?.["update:logistica"]);

  useEffect(() => {
    setConferma(false);
    setRimborsoParziale(false);
    setQuantitaRimborsata("1");
    setShowSpostamentoModa(false);
    setShowSpostamentoManuale(false);
    setOpzioniSpostamentoModa(null);
    setErroreSpostamentoModa("");
    setAlertSalvataggio(false);
    setMostraModaInfo(false);
    setModaInfo(null);
    setErroreModa("");
    setLoadingSpostamentoModa(false);
    return () => richiestaOpzioniRef.current?.abort();
  }, [articolo[`ID Articolo`]]);

  useEffect(() => {
    const loadToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (err) {
        console.error("Token non disponibile", err);
      }
    };
    loadToken();
  }, [getAccessTokenSilently, user?.sub]);

  /* useEffect(() => {
        setRows(listaArticoli)
      }, [alertSalvataggio]);
 */
  const { inputClassesNOW, classiTastoSblocco } = stilePulsanti;

  if (!(i % 2 === 0)) {
    className = className + "  sfondoColChiaro";
  }

  if (articolo["Quantità"] < 1) {
    className = className + " eliminato";
  }

  const toggleModaInfo = async () => {
    const codVS = articolo?.["Cod Viglietti Sport"];
    if (!codVS) {
      setErroreModa("Codice VS mancante");
      setMostraModaInfo((prev) => !prev);
      return;
    }
    if (!token) {
      setErroreModa("Token non disponibile");
      return;
    }
    if (modaInfo || mostraModaInfo) {
      setMostraModaInfo((prev) => !prev);
      return;
    }
    setLoadingModa(true);
    setErroreModa("");
    try {
      const response = await axios.get(
        `${apiUrl}/moda/articoli/${encodeURIComponent(codVS)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.data) {
        setModaInfo(response.data.data);
      } else {
        setErroreModa("Nessun dato Moda trovato");
      }
    } catch (error) {
      setErroreModa(error?.message || "Errore caricamento dati Moda");
    } finally {
      setLoadingModa(false);
      setMostraModaInfo(true);
    }
  };

  const copiaValoreModa = async (valoreRaw) => {
    const valore = valoreRaw ?? "";
    if (!valore) return;
    try {
      await navigator.clipboard.writeText(String(valore));
      setCopiedModaValue(String(valore));
      setTimeout(() => setCopiedModaValue(""), 1500);
    } catch (error) {
      console.error("Copia valore moda fallita", error);
    }
  };

  const caricaOpzioniSpostamentoModa = async () => {
    if (!canUpdateLogistica || eliminazioneInCorso || splitInCorso) return;
    if (modificheNonSalvate) {
      setAlertSalvataggio("Salva le modifiche prima di spostare articoli in un’altra spedizione.");
      return;
    }
    richiestaOpzioniRef.current?.abort();
    const controller = new AbortController();
    richiestaOpzioniRef.current = controller;
    setOpzioniSpostamentoModa(null);
    setShowSpostamentoModa(true);
    setLoadingSpostamentoModa(true);
    setErroreSpostamentoModa("");
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await axios.get(
        `${apiUrl}/logistica/ordine/opzioniSpostamentoArticoloModa`,
        {
          params: {
            idSped: idOrdineDatabase,
            idArticolo: articolo?.["ID Articolo"],
          },
          signal: controller.signal,
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
      if (!controller.signal.aborted) setOpzioniSpostamentoModa(response.data);
    } catch (error) {
      if (controller.signal.aborted) return;
      setErroreSpostamentoModa(
        error?.response?.data?.error ||
          error?.message ||
          "Errore caricamento opzioni spostamento",
      );
    } finally {
      if (!controller.signal.aborted) setLoadingSpostamentoModa(false);
    }
  };

  const apriSpostamentoArticolo = () => {
    if (!canUpdateLogistica || eliminazioneInCorso || splitInCorso || loadingSpostamentoModa) return;
    if (!articolo["ID Articolo"]) {
      setAlertSalvataggio("Salva prima l’articolo per poterlo spostare.");
      return;
    }
    if (modificheNonSalvate) {
      setAlertSalvataggio("Salva le modifiche prima di spostare articoli in un’altra spedizione.");
      return;
    }
    if (articolo.mag_partenza) {
      caricaOpzioniSpostamentoModa();
    } else {
      setConferma(false);
      setShowSpostamentoManuale((prev) => !prev);
    }
  };

  const spostaArticoloModa = async ({ idSpedDestinazione, creaNuovoSplit }) => {
    if (loadingSpostamentoModa) return;
    if (!canUpdateLogistica || eliminazioneInCorso || splitInCorso) return;
    if (modificheNonSalvate) {
      setAlertSalvataggio("Salva le modifiche prima di spostare articoli in un’altra spedizione.");
      return;
    }
    setLoadingSpostamentoModa(true);
    setErroreSpostamentoModa("");
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await axios.post(
        `${apiUrl}/logistica/ordine/spostaArticoloSplitModa`,
        {
          utente: utente.username,
          idSpedOrigine: idOrdineDatabase,
          idArticolo: articolo?.["ID Articolo"],
          idSpedDestinazione,
          creaNuovoSplit,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
      setAlertSalvataggio(
        response.data?.nuovoSplitCreato
          ? `Nuovo split creato: ${response.data.idSpedDestinazione}`
          : `Articolo spostato nella spedizione ${response.data.idSpedDestinazione}`,
      );
      setShowSpostamentoModa(false);
      setOpzioniSpostamentoModa(null);
      if (onArticoloSpostato) {
        onArticoloSpostato(response.data);
      }
    } catch (error) {
      setErroreSpostamentoModa(
        error?.response?.data?.error ||
          error?.message ||
          "Errore spostamento articolo",
      );
    } finally {
      setLoadingSpostamentoModa(false);
    }
  };

  const magPrenotazioneSpostamento =
    opzioniSpostamentoModa?.articolo?.magPrenotazione;
  const motivoDestinazioneNonConsentita = (sped) =>
    `Non selezionabile: parte da ${sped.partenzaDa || "partenza non impostata"}, ` +
    `l’articolo è prenotato su ${magPrenotazioneSpostamento || "magazzino non impostato"}`;

  const magazziniSnapshot =
    Array.isArray(magazziniAttivi)
      ? magazziniAttivi
          .map((magazzino) => ({
            sigla: String(magazzino?.sigla || "")
              .trim()
              .toUpperCase(),
            label:
              magazzino?.nome ||
              magazzino?.descPartenzaDa ||
              magazzino?.sigla,
            descPartenzaDa: magazzino?.descPartenzaDa,
          }))
          .filter((magazzino) =>
            SIGLE_SNAPSHOT_SUPPORTATE.has(magazzino.sigla),
          )
      : SNAPSHOT_MAGAZZINI_DEFAULT;

  const snapshotRows = [
    ...magazziniSnapshot.map((magazzino) => ({
      ...magazzino,
      g: articolo[`g_${magazzino.sigla}`],
      i: articolo[`i_${magazzino.sigla}`],
    })),
    {
      sigla: "F",
      label: "Magazzini Fornitore",
      g: articolo.g_F ?? articolo["g_F"],
      i: null,
    },
  ];

  const statoWebModaCodice =
    articolo?.moda_stato_web_codice ?? articolo?.["moda_stato_web_codice"];
  const statoWebModaDescrizione =
    articolo?.moda_stato_web_descrizione ??
    articolo?.["moda_stato_web_descrizione"];
  const classeStatoPrenotazione = {
    0: "colPreparazione",
    10: "scrittaVerde",
    13: "scrittaVerde",
    20: "scrittaRosso",
    30: "colAttesa",
    40: "colSpedito",
    50: "colAnnullato",
  }[String(statoWebModaCodice ?? "").trim()] || "";
  const classeStatoMagazzino = {
    DA_TROVARE: "scrittaRosso",
    PARZIALE: "scrittaArancio",
    TROVATO: "scrittaVerde",
    PRONTO: "scrittaVerde",
  }[articolo.magazzino?.stato_magazzino] || "";
  const totalePezzi = Number(articolo.magazzino?.pezzi ?? 0);
  const trovati = Number(articolo.magazzino?.trovati ?? 0);
  const pronti = Number(articolo.magazzino?.pronti ?? 0);
  const classeConteggio = (conteggio) =>
    totalePezzi > 0 && conteggio >= totalePezzi ? "scrittaVerde" : "";
  const classiAzioneHeader = "articolo-azione tastoBianco ba bordoColAlt br3 pointer dim";
  const leggiBoolArticolo = (campo) => Number(articolo?.[campo] ?? 0) === 1;

  const eliminaArticolo = async function () {
    if (!canUpdateLogistica || eliminazioneInCorso || splitInCorso || loadingSpostamentoModa) {
      return;
    }
    if (articolo[`ID Articolo`]) {
      if (!token) {
        setAlertSalvataggio("Token non disponibile");
        return;
      }
      const data = {
        username: utente.username,
        idDaCancellare: [
          {
            tabella: `Sped/Art`,
            dato: `ID Articoli`,
            valore: articolo[`ID Articolo`],
          },
          {
            tabella: "Articoli",
            dato: `ID Articolo`,
            valore: articolo[`ID Articolo`],
          },
        ],
      };
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      setEliminazioneInCorso(true);
      setAlertSalvataggio(false);
      try {
        const accessToken = await getAccessTokenSilently();
        config.headers.Authorization = `Bearer ${accessToken}`;
        const res = await axios.patch(
          apiUrl + "/logistica/ordine/deleteIDconFeedback",
          data,
          config,
        );
        if (res.data.risultati) {
          setConferma(false);
          rimuoviDaArr("articoliArr", i);
        } else if (res.data.err) {
          setAlertSalvataggio(res.data.err);
        } else if (res.data.error) {
          setAlertSalvataggio(res.data.error);
        }
      } catch (err) {
        setAlertSalvataggio(err.response?.data?.error || err.message);
      } finally {
        setEliminazioneInCorso(false);
      }
    } else {
      setConferma(false);
      rimuoviDaArr("articoliArr", i);
    }
  };

  const aggiornaBoolArticolo = async function (dato, valore) {
    if (!token) {
      setAlertSalvataggio("Token non disponibile");
      return;
    }
    if (canUpdateLogistica) {
      const data = {
        utente: utente,
        permessi: permessi,
        idArticolo: articolo[`ID Articolo`],
        codiceVS: articolo["Cod Viglietti Sport"]
          ? articolo["Cod Viglietti Sport"]
          : "",
        descArticolo: articolo["Descrizione Articolo"]
          ? articolo["Descrizione Articolo"]
          : articolo["Cod Viglietti Sport"],
        idOrdinePS: idOrdinePS ? idOrdinePS : idOrdineDatabase,
        idOrdineDatabase: idOrdineDatabase,
        datoBooleano: dato,
        valoreBooleano: valore,
      };
      axios
        .patch(
          apiUrl + "/logistica/ordine/cambioBoolArticoloConFeedback",
          data,
          { headers: { Authorization: "Bearer " + token } },
        )
        .then((res) => {
          if (res.data?.error) {
            setAlertSalvataggio(res.data.error);
            return;
          }
          setAlertSalvataggio("Dato articolo aggiornato");
          const valoreAggiornato = valore === "NULL" ? null : Number(valore);
          handleChange({
            target: {
              name: "articoliArr[" + i + ']["' + dato + '"]',
              value: valoreAggiornato,
            },
          });
        })
        .catch((error) => {
          setAlertSalvataggio(
            error?.response?.data?.error ||
              error?.message ||
              "Errore aggiornamento dato articolo",
          );
        });
    }
  };

  const impostaBooloNullo = async function (dato, valore) {
    if (utente.permessiAPI["magazzino:torino"]) {
      aggiornaBoolArticolo(dato, valore);
    }
  };

  const toggleFlagArticolo = function (dato) {
    const nuovoValore = leggiBoolArticolo(dato) ? "0" : "1";
    aggiornaBoolArticolo(dato, nuovoValore);
  };

  const flagArticolo = function (dato, label) {
    if (!leggiBoolArticolo(dato)) return null;
    return (
      <button
        type="button"
        className="articolo-flag sfondoColScuro white b f7 bn br2 ph2 pv1"
        aria-label={label}
        onClick={() => canUpdateLogistica && toggleFlagArticolo(dato)}
        disabled={!canUpdateLogistica}
        title={canUpdateLogistica ? "Disattiva " + label : label}
      >
        {label}
      </button>
    );
  };

  const azioneInCorso = eliminazioneInCorso || splitInCorso || loadingSpostamentoModa;
  const quantitaArticolo = Number(articolo["Quantità"]);
  const applicaRimborso = (parziale) => {
    if (!canUpdateLogistica || azioneInCorso) return;
    if (!rimborsoPresente) {
      setAlertSalvataggio("Aggiungi un rimborso in Resi e rimborsi di questa spedizione, anche senza salvarlo, prima di ridurre la quantità.");
      return;
    }
    const quantita = parziale ? Number(quantitaRimborsata) : quantitaArticolo;
    if (!Number.isInteger(quantita) || quantita < 1 || (parziale && quantita >= quantitaArticolo)) {
      setAlertSalvataggio(`Indica un numero intero di pezzi rimborsati tra 1 e ${quantitaArticolo - 1}.`);
      return;
    }
    if (onRimborsaArticolo?.(quantita)) {
      setConferma(false);
      setRimborsoParziale(false);
      setShowSpostamentoModa(false);
      setAlertSalvataggio("Quantità aggiornata. Salva l’ordine per confermare la modifica.");
    }
  };

  return (
      <div
        className={
          className + " flex flex-wrap justify-between pa3 pl4 pr4 br4 mb3"
        }
      >
        <div className="articolo-header pb2 flex w-100 items-center">
          {/* <pre>{JSON.stringify(utente.permessiAPI, null, 2)}</pre> */}
          <div className="f4 mr2">{i + 1}.</div>
          {/* INIZIO GROSSO CASINO DEI BOOLEAN */}
          {/* <p>{`articolo["trovato"]: `+articolo["trovato"]}</p> */}
          <div className="articolo-header-controlli flex items-center flex-wrap">
            {utente.permessiAPI["update:logistica"] &&
              articolo["trovato"] == 1 && (
                <div
                  className="br3 flex items-center pointer justify-center white pl2 pr2 fw5"
                  onClick={(e) => impostaBooloNullo("trovato", "NULL")}
                >
                  <span className="material-icons br4 colEtichette">done</span>
                </div>
              )}
            {utente.permessiAPI["update:logistica"] &&
              (!articolo["trovato"] || articolo["trovato"] == 0) && (
                <div
                  className="br3 flex items-center pointer justify-center white pl2 pr2 fw5"
                  onClick={(e) => impostaBooloNullo("trovato", "1")}
                >
                  <span className="material-icons br4 ba b--black-20 scrittaVerde">
                    done
                  </span>
                </div>
              )}
            {utente.permessiAPI["update:logistica"] &&
              articolo["trovato"] == 0 && (
                <div
                  className="br3 flex items-center pointer justify-center white pl2 pr2 fw5"
                  onClick={(e) => impostaBooloNullo("trovato", "NULL")}
                >
                  <span className="material-icons br4 colAnnullato">close</span>
                </div>
              )}
            {utente.permessiAPI["update:logistica"] &&
              (articolo["trovato"] === null || articolo["trovato"] == 1) && (
                <div
                  className="br3 flex items-center pointer justify-center white pl2 pr2 fw5"
                  onClick={(e) => impostaBooloNullo("trovato", "0")}
                >
                  <span className="material-icons br4 ba b--black-20 scrittaRosso">
                    close
                  </span>
                </div>
              )}
            <div className="articolo-header-azioni flex items-center">
              <button
                type="button"
                className={classiAzioneHeader}
                onClick={() => setShowSnapshot(true)}
                title="Giacenze all’importazione"
                aria-label="Giacenze all’importazione"
              >
                <span className="material-icons" aria-hidden="true">inventory_2</span>
              </button>
              <button
                type="button"
                className={classiAzioneHeader}
                onClick={toggleModaInfo}
                title={mostraModaInfo ? "Chiudi informazioni articolo" : "Informazioni articolo Moda"}
                aria-label="Informazioni articolo Moda"
                aria-pressed={mostraModaInfo}
              >
                <span className="material-icons" aria-hidden="true">{mostraModaInfo ? "close" : "info"}</span>
              </button>
            {canUpdateLogistica && (
                <button
                  type="button"
                  className={classiAzioneHeader}
                  aria-label="Sposta articolo tra split"
                  onClick={apriSpostamentoArticolo}
                  disabled={azioneInCorso}
                  title="Sposta articolo tra split"
                >
                  <span className="material-icons" aria-hidden="true">swap_horiz</span>
                </button>
              )}
            </div>
          </div>
          {/* FINE GROSSO CASINO DEI BOOLEAN */}
          {canUpdateLogistica && (
            <button
              type="button"
              aria-label="Elimina articolo"
              title="Elimina articolo"
              aria-expanded={conferma}
              className={classiAzioneHeader + " material-icons"}
              disabled={azioneInCorso}
              onClick={() => { setConferma(!conferma); setRimborsoParziale(false); setAlertSalvataggio(false); }}
            >
              delete
            </button>
          )}
        </div>

        {alertSalvataggio && (
          <div className="w-100 colAnnullato mb2">{alertSalvataggio}</div>
        )}
        {showSpostamentoManuale && canUpdateLogistica && (
          <div className="w-100 ba bordoColAlt br3 pa3 mb3" role="region" aria-label="Spostamento articolo">
            <p className="b mt0">Sposta articolo</p>
            {onCreaSplit && (
              <button
                type="button"
                className={stilePulsanti.buttonClassesWhite + " mb2"}
                disabled={azioneInCorso}
                onClick={() => onCreaSplit(articolo["ID Articolo"])}
              >
                Sposta in una nuova spedizione
              </button>
            )}
            <button
              type="button"
              className={stilePulsanti.buttonClassesWhite + " mb2"}
              disabled={azioneInCorso}
              onClick={() => setShowSpostamentoManuale(false)}
            >
              Annulla
            </button>
          </div>
        )}
        {conferma && canUpdateLogistica && (
          <div className="articolo-motivi-rimozione w-100 ba bordoColAlt br3 pa3 mb3" role="region" aria-label="Conferma eliminazione articolo">
            <p className="b mt0">Perché vuoi eliminare questo articolo?</p>
            <button
              type="button"
              className={stilePulsanti.buttonClassesRed + " mb2"}
              disabled={azioneInCorso}
              onClick={eliminaArticolo}
            >
              Lo voglio rimuovere dall'ordine per sostituirlo con un nuovo articolo che aggiungo a mano
            </button>
            <button type="button" className={stilePulsanti.buttonClassesRed + " mb2"}
              disabled={azioneInCorso} onClick={eliminaArticolo}>
              Lo elimino perché l'ho aggiunto a mano e come l'ho fatto lo distruggo
            </button>
            <button type="button" className={stilePulsanti.buttonClassesWhite + " mb2"}
              disabled={azioneInCorso || quantitaArticolo <= 0} onClick={() => applicaRimborso(false)}>
              L'ho rimborsato (richiede rimborso registrato in questa spedizione)
            </button>
            {quantitaArticolo > 1 && (
              <button type="button" className={stilePulsanti.buttonClassesWhite + " mb2"}
                disabled={azioneInCorso} onClick={() => { setRimborsoParziale(true); setQuantitaRimborsata("1"); setAlertSalvataggio(false); }}>
                Ne ho rimborsata una parte
              </button>
            )}
            {rimborsoParziale && quantitaArticolo > 1 && (
              <div className="ba bordoColAlt br3 pa2 mb2">
                <label className="db mb2">
                  Quanti pezzi hai rimborsato?
                  <input type="number" min="1" max={quantitaArticolo - 1} step="1"
                    className={inputClassesNOW + " db mt2"} value={quantitaRimborsata}
                    disabled={azioneInCorso} onChange={(e) => setQuantitaRimborsata(e.target.value)} />
                </label>
                <p>Richiede un rimborso in questa spedizione, anche non ancora salvato.</p>
                <button type="button" className={stilePulsanti.buttonClassesWhite}
                  disabled={azioneInCorso} onClick={() => applicaRimborso(true)}>
                  Conferma quantità rimborsata
                </button>
              </div>
            )}
            {articolo["ID Articolo"] && onCreaSplit && (
              <button
                type="button"
                className={stilePulsanti.buttonClassesWhite + " mb2"}
                disabled={azioneInCorso}
                onClick={() => onCreaSplit(articolo["ID Articolo"])}
              >
                Lo voglio spostare in una nuova spedizione
              </button>
            )}
            {articolo["ID Articolo"] && articolo.mag_partenza && (
              <button
                type="button"
                className={stilePulsanti.buttonClassesWhite + " mb2"}
                disabled={azioneInCorso}
                onClick={caricaOpzioniSpostamentoModa}
              >
                Lo voglio spostare in uno degli split già esistenti per questo articolo
              </button>
            )}
            {!articolo["ID Articolo"] && <p>Salva prima l’articolo per poterlo spostare.</p>}
            <button
              type="button"
              className={stilePulsanti.buttonClassesWhite + " mb2"}
              disabled={azioneInCorso}
              onClick={() => { setConferma(false); setShowSpostamentoModa(false); setRimborsoParziale(false); setAlertSalvataggio(false); }}
            >
              Annulla
            </button>
          </div>
        )}

        <div className="db dn-ns dn-m w-100 tc">
          {(articolo?.["Cod Viglietti Sport"] ||
            (articolo["imgIDps"] && articolo["prodIDps"])) && (
            <div className="w-100 mb3">
              <ImgArt
                prodIDps={articolo["prodIDps"]}
                imgIDps={articolo["imgIDps"]}
                size="small_default"
                imageClassName="articolo-anteprima"
                fonte={fonteOrdine || articolo?.fonte}
                codVS={articolo?.["Cod Viglietti Sport"]}
                token={token}
              />
              <br />
            </div>
          )}
        </div>

        <InputDatoProdotto
          inputLabel="EAN"
          datoName={"articoliArr[" + i + ']["Codice EAN"]'}
          datoId="codEAN"
          datoValue={articolo?.["Codice EAN"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-85 h-100"}
          datoClass={"w-35"}
          labelClass={"w-15"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            !identitaCongelata && canUpdateLogistica ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="VS"
          datoName={"articoliArr[" + i + ']["Cod Viglietti Sport"]'}
          datoId="codVS"
          datoValue={articolo?.["Cod Viglietti Sport"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100 f6"}
          datoClass={"w-20"}
          labelClass={"w-20"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            !identitaCongelata && canUpdateLogistica ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="Brand"
          datoName={"articoliArr[" + i + ']["Produttore"]'}
          datoId="brand"
          datoValue={articolo?.["Produttore"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-85 h-100"}
          datoClass={"w-40"}
          labelClass={"w-15"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            !identitaCongelata && utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <div className="flex w-100 items-center">
          {(articolo?.["Cod Viglietti Sport"] ||
            (articolo["imgIDps"] && articolo["prodIDps"])) && (
            <div className="articolo-anteprima-contenitore mb3 dn db-ns">
              <ImgArt
                prodIDps={articolo["prodIDps"]}
                imgIDps={articolo["imgIDps"]}
                size="small_default"
                imageClassName="articolo-anteprima"
                fonte={fonteOrdine || articolo?.fonte}
                codVS={articolo?.["Cod Viglietti Sport"]}
                token={token}
              />
              <br />
            </div>
          )}
          {!mostraModaInfo && !identitaCongelata && canUpdateLogistica && (
            <textarea
              type="text"
              rows="6"
              /* cols="70" */
              name={"articoliArr[" + i + ']["Descrizione Articolo"]'}
              value={articolo?.["Descrizione Articolo"] ?? ""}
              onChange={handleChange}
              className={inputClassesNOW + " w-70 ma2 mb3"}
            />
          )}
          {!mostraModaInfo && (identitaCongelata || !canUpdateLogistica) && (
            <p className="ma2">{articolo?.["Descrizione Articolo"] ?? ""}</p>
          )}
          {mostraModaInfo && (
            <div className="w-100 flex items-center mt2">
              {loadingModa && <span className="gray f7">Caricamento…</span>}
              {erroreModa && (
                <span className="dark-red f7 ml2">{erroreModa}</span>
              )}
              {mostraModaInfo && modaInfo && (
                <div className="w-100 mt2 ba b--black-10 br2 pa2 bg-washed-blue">
                  <div className="flex flex-wrap">
                    <button
                      type="button"
                      className="mr3 mb2 bg-transparent bn tl pointer"
                      onClick={() => copiaValoreModa(modaInfo?.codProd ?? "-")}
                      title="Copia valore"
                    >
                      <div className="gray f7">Cod. Prod.</div>
                      <div className="b underline-hover">
                        {modaInfo?.codProd ?? "-"}
                      </div>
                    </button>
                    <button
                      type="button"
                      className="mr3 mb2 bg-transparent bn tl pointer"
                      onClick={() => copiaValoreModa(modaInfo?.codMod ?? "-")}
                      title="Copia valore"
                    >
                      <div className="gray f7">Cod. Mod.</div>
                      <div className="b underline-hover">
                        {modaInfo?.codMod ?? "-"}
                      </div>
                    </button>
                    <button
                      type="button"
                      className="mr3 mb2 bg-transparent bn tl pointer"
                      onClick={() => copiaValoreModa(modaInfo?.codCol ?? "-")}
                      title="Copia valore"
                    >
                      <div className="gray f7">Cod. Col.</div>
                      <div className="b underline-hover">
                        {modaInfo?.codCol ?? "-"}
                      </div>
                    </button>
                    {copiedModaValue && (
                      <span className="gray f7 ml2">
                        Copiato: {copiedModaValue}
                      </span>
                    )}
                    {loadingModa && (
                      <span className="gray f7 ml2">Caricamento…</span>
                    )}
                    {erroreModa && (
                      <span className="dark-red f7 ml2">{erroreModa}</span>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <InputDatoProdotto
          inputLabel="Imp. unit"
          datoName={"articoliArr[" + i + ']["Importo unitario"]'}
          tipoInput="number"
          datoId="impUnit"
          datoValue={articolo?.["Importo unitario"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={(e) => handleChangeImportoArticolo(e, i)}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-25"}
          labelClass={"w-20"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            canUpdateLogistica ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="pz."
          tipoInput="number"
          min={quantitaArticolo === 0 && rimborsoPresente ? 0 : 1}
          datoName={"articoliArr[" + i + ']["Quantità"]'}
          datoId="quant"
          datoValue={articolo?.["Quantità"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={(e) => handleChangeImportoArticolo(e, i)}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-20"}
          labelClass={"w-20"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            !identitaCongelata && canUpdateLogistica ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="Tot. riga"
          datoName={"articoliArr[" + i + ']["Totale riga"]'}
          tipoInput="number"
          datoId="totRiga"
          datoValue={articolo?.["Totale riga"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-25"}
          labelClass={"w-20"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <div className="articolo-stati w-100 mt2 mb3">
          <div className="articolo-stato ba bordoColAlt br3 pa2">
            <div className="f7 mb2">Prenotazione</div>
            <div className={"b br2 ph1 " + classeStatoPrenotazione}
              title={statoWebModaCodice != null ? `Codice: ${statoWebModaCodice}` : undefined}>
              {statoWebModaDescrizione || (statoWebModaCodice != null && statoWebModaCodice !== "" ? statoWebModaCodice : "—")}
            </div>
          </div>
          <div className="articolo-stato ba bordoColAlt br3 pa2">
            <div className="f7 mb2">Magazzino</div>
            <div className={"b " + classeStatoMagazzino}>
              {articolo.magazzino?.stato_magazzino?.replaceAll("_", " ") || "DA CLASSIFICARE"}
            </div>
            {articolo.magazzino && <div className="f7 mt2 b">
              <div className={classeConteggio(trovati)}>T: {trovati}/{totalePezzi}</div>
              <div className={classeConteggio(pronti)}>P: {pronti}/{totalePezzi}</div>
            </div>}
          </div>
        </div>
        {(leggiBoolArticolo("inv_sharing") || leggiBoolArticolo("dropshipping")) && (
          <div className="articolo-flags flex flex-wrap w-100 mb3">
            {flagArticolo("inv_sharing", "Inv. sharing")}
            {flagArticolo("dropshipping", "Dropshipping")}
          </div>
        )}
        {(!identitaCongelata || articolo.rimborso_articolo) && canUpdateLogistica && Number(articolo["Quantità"]) < (articolo.mag_unita?.length || 0) && (
          <fieldset className="w-100 mb3"><legend>Seleziona i pezzi da rimuovere per la riduzione quantità</legend>
            {articolo.mag_unita.map(u=><label key={u.id} className="db"><input type="checkbox" checked={(articolo.mag_unita_rimosse || []).includes(u.id)} onChange={e=>handleChange({target:{name:`articoliArr[${i}]["mag_unita_rimosse"]`,value:e.target.checked?[...(articolo.mag_unita_rimosse || []),u.id]:(articolo.mag_unita_rimosse || []).filter(id=>id!==u.id)}})}/>
              Pezzo {u.id} · {u.barcode || "Matricola non associata"} · {u.stato}</label>)}
          </fieldset>
        )}

        {showSnapshot && (
          <div
            className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
          >
            <div className="bg-white pa3 br3 shadow-4 w-80 w-30-ns">
              <div className="flex justify-between items-center pt3 pb4">
                <div>
                  <div className="ttu b">Snapshot giacenze</div>
                  <small>
                    Le giacenze sono una fotografia del momento in cui l'ordine
                    è stato importato.
                  </small>
                </div>
                <button
                  type="button"
                  className={stilePulsanti.buttonClassesWhite + " pv1"}
                  onClick={() => setShowSnapshot(false)}
                >
                  Chiudi
                </button>
              </div>
              <div className="overflow-auto" style={{ maxHeight: "60vh" }}>
                {/* Intestazione tabella */}
                <div className="flex items-center justify-between ba b--black-20 br2 pa2 mb2 bg-light-gray fw7">
                  <div className="w-60">
                    <div className="b tr pr4">Magazzino</div>
                  </div>
                  <div className="w-20">
                    <div className="tc">Giacenze</div>
                  </div>
                  <div className="w-20">
                    <div className="tc">Impegni</div>
                  </div>
                </div>
                {snapshotRows.map((row) => {
                  const magPartenzaRaw =
                    articolo.mag_partenza ?? articolo["mag_partenza"] ?? "";
                  const magPartenzaNorm = magPartenzaRaw
                    ?.toString()
                    .trim()
                    .toLowerCase();

                  const siglaPartenzaFromDesc = (() => {
                    if (!magPartenzaNorm) return null;
                    if (magPartenzaNorm.includes("fornit")) return "F";
                    const magazzinoConfigurato = snapshotRows.find((row) =>
                      [row.label, row.descPartenzaDa]
                        .filter(Boolean)
                        .some(
                          (valore) =>
                            String(valore).trim().toLowerCase() ===
                            magPartenzaNorm,
                        ),
                    );
                    if (magazzinoConfigurato) return magazzinoConfigurato.sigla;
                    if (magPartenzaNorm.includes("villanova")) return "VM";
                    if (magPartenzaNorm.includes("torino")) return "JS";
                    if (magPartenzaNorm.includes("prato")) return "PN";
                    if (magPartenzaNorm.includes("cherasco")) return "CH";
                    if (
                      magPartenzaNorm.includes("roveri") ||
                      magPartenzaNorm.includes("royal")
                    )
                      return "RV";
                    if (magPartenzaNorm.includes("vernante")) return "VE";
                    if (magPartenzaNorm.includes("limone 1400")) return "L4";
                    if (magPartenzaNorm.includes("borgo")) return "CU";
                    if (magPartenzaNorm === "limone") return "LM";
                    if (magPartenzaNorm.includes("marro")) return "MG";
                    return null;
                  })();

                  const evidenziato =
                    (siglaPartenzaFromDesc &&
                      siglaPartenzaFromDesc === row.sigla) ||
                    (!siglaPartenzaFromDesc &&
                      row.sigla !== "F" &&
                      magPartenzaNorm &&
                      magPartenzaNorm.includes(row.sigla.toLowerCase()));

                  const cellClass = (val) => {
                    if (val === null || val === undefined || val === "")
                      return "";
                    const num = Number(val);
                    if (Number.isNaN(num)) return "";
                    if (num < 0) return "dark-red";
                    if (num === 0) return "light-silver";
                    return "";
                  };
                  return (
                    <div
                      key={row.sigla}
                      className={
                        "flex items-center justify-between ba b--black-10 br2 pa2 mb2 " +
                        (evidenziato ? "bg-washed-green" : "")
                      }
                    >
                      <div className="w-60">
                        <div className="b tr pr4">{row.label}</div>
                      </div>
                      <div className="w-20">
                        <div className={`b tc ${cellClass(row.g)}`}>
                          {row.g ?? "-"}
                        </div>
                      </div>
                      <div className="w-20">
                        <div className={`b tc ${cellClass(row.i)}`}>
                          {row.i ?? "-"}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showSpostamentoModa && (
          <div
            className={conferma ? "w-100 mb3" : "fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center"}
            style={conferma ? undefined : { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
          >
            <div className={conferma ? "sfondoBiancoTema pa3 br3 ba bordoColAlt" : "bg-white pa3 br3 shadow-4 w-90 w-60-ns"}>
              <div className="flex justify-between items-center pt3 pb3">
                <div>
                  <div className="ttu b">Sposta articolo split</div>
                  <small>
                    {articolo?.["Cod Viglietti Sport"]} -{" "}
                    {articolo?.["Descrizione Articolo"]}
                  </small>
                </div>
                <button
                  type="button"
                  className={stilePulsanti.buttonClassesWhite + " pv1"}
                  disabled={loadingSpostamentoModa}
                  onClick={() => setShowSpostamentoModa(false)}
                >
                  Chiudi
                </button>
              </div>

              {loadingSpostamentoModa && (
                <BlockSkeleton height={100} className="mb3" />
              )}
              {erroreSpostamentoModa && (
                <div className="dark-red b mb3">{erroreSpostamentoModa}</div>
              )}

              {opzioniSpostamentoModa && (
                <>
                  <div className="mb3">
                    <span className="gray">Mag prenotazione Moda: </span>
                    <span className="b">
                      {opzioniSpostamentoModa.articolo?.magPrenotazione || "-"}
                    </span>
                    <span className="gray ml3">Stato Moda: </span>
                    <span className="b">
                      {opzioniSpostamentoModa.articolo?.statoModaDescrizione ||
                        "-"}
                    </span>
                  </div>

                  {!opzioniSpostamentoModa.spedizioni?.some(
                    (sped) => !sped.corrente && sped.destinazioneConsentita,
                  ) && (
                    <div className="dark-red mb3">
                      Nessuna spedizione esistente parte da{" "}
                      {magPrenotazioneSpostamento || "un magazzino prenotazione Moda"}:
                      usa Crea nuovo split.
                    </div>
                  )}

                  <div className="overflow-auto" style={{ maxHeight: "50vh" }}>
                    {opzioniSpostamentoModa.spedizioni?.map((sped) => (
                      <div
                        key={sped.idSped}
                        className={
                          "ba b--black-10 br2 pa2 mb2 flex flex-wrap items-center " +
                          (sped.corrente ? "bg-near-white " : "") +
                          (sped.statoDestinazioneDiversoDaPreparazione
                            ? "b--dark-red "
                            : "")
                        }
                      >
                        <div className="w-20 b">#{sped.idSped}</div>
                        <div className="w-20">{sped.partenzaDa || "-"}</div>
                        <div
                          className={
                            "w-20 " +
                            (sped.statoDestinazioneDiversoDaPreparazione
                              ? "dark-red b"
                              : "")
                          }
                        >
                          {sped.statoOrdine || "-"}
                        </div>
                        <div className="w-15">{sped.corriere || "-"}</div>
                        <div className="w-15">
                          {Number(sped.importoContrassegno) > 0
                            ? `COD ${sped.importoContrassegno}`
                            : "no COD"}
                        </div>
                        <div className="w-10 tr">
                          {sped.corrente ? (
                            <span className="gray f7">corrente</span>
                          ) : (
                            <button
                              type="button"
                              className={
                                stilePulsanti.buttonClassesWhite +
                                " pv1" +
                                (sped.destinazioneConsentita ? "" : " o-40")
                              }
                              disabled={
                                !sped.destinazioneConsentita ||
                                loadingSpostamentoModa
                              }
                              onClick={() =>
                                spostaArticoloModa({
                                  idSpedDestinazione: sped.idSped,
                                  creaNuovoSplit: false,
                                })
                              }
                            >
                              Sposta
                            </button>
                          )}
                        </div>
                        <div className="w-100 f7 gray mt1">
                          Articoli: {sped.numeroArticoli || 0} - Stato Moda:{" "}
                          {sped.statoModaOrdine || "-"}
                          {sped.statoDestinazioneDiversoDaPreparazione
                            ? " - Stato destinazione diverso da PREPARAZIONE"
                            : ""}
                          {!sped.corrente && !sped.destinazioneConsentita && (
                            <span className="dark-red">
                              {" - "}
                              {motivoDestinazioneNonConsentita(sped)}
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="tr mt3">
                    <button
                      type="button"
                      className={stilePulsanti.buttonClassesGreen + " pv2"}
                      disabled={loadingSpostamentoModa}
                      onClick={() =>
                        spostaArticoloModa({
                          creaNuovoSplit: true,
                        })
                      }
                    >
                      Crea nuovo split
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
}

export default Articolo;
